export default __webpack_public_path__ + "static/Group 283-551299aee0070105a95913217da252a7.webp";